import StringUtil from '@/utils/StringUtil'

export default {
  getAsFormData: (ob) => {
    const data = new FormData()

    for (const p of Object.keys(ob)) {
      data.append(p, ob[p])
    }

    return data
  },
  isByteArraysEqual: async (blob1, blob2) => {
    const minLimit = 1024 * 2
  
    if (blob1.size < minLimit) console.warn(`${blob1}'s size is smaller than 2KB`)
    if (blob2.size < minLimit) console.warn(`${blob2}'s size is smaller than 2KB`)
  
    const arr1 = await blob1.arrayBuffer()
    const arr2 = await blob2.arrayBuffer()
  
    if (!StringUtil.isEqual(arr1.byteLength, arr2.byteLength)) return false
  
    const int32Array1 = new Int32Array(arr1, 0, minLimit)
    const int32Array2 = new Int32Array(arr2, 0, minLimit)
    
    for(let i = 0; i < minLimit; i++) {
      if (!StringUtil.isEqual(int32Array1.at(i), int32Array2.at(i))) return false
    }
  
    return true
  }
}


// *************** FILE STRUCTURE ***************
// {
//   "lastModified": 1734445692077,
//   "lastModifiedDate": "2024-12-17T14:28:12.077Z",
//   "name": "Статии.docx",
//   "size": 19639,
//   "type": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//   "webkitRelativePath": ""
// }
// **********************************************
export function getFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  })
}
export function getSizeInApproximateUnit(size) {
  const units = [
    "B",
    "KB",
    "MB",
    "GB"
  ]

  let unitPointer = 0
  let sizeWorkWith = size
  while (sizeWorkWith / 1000 > 1) {
    sizeWorkWith /= 1000
    ++unitPointer
  }

  return `${Number(sizeWorkWith).toFixed(2)} ${units[unitPointer]}`
}